import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
  ) {
    const dataParam = activatedRoute.snapshot.queryParams;

    if (dataParam.data) {
      const token: string = dataParam.data;
      const decoded = atob(token);
      const tokenData = JSON.parse(decoded);
      localStorage.setItem('token', JSON.stringify(tokenData.data));
      localStorage.setItem('skipTokenRemoval', 'true');
      window.location.reload();
    }
  }

  ngOnInit(): void {
  }
}
